import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "d-flex justify-content-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RoleDetail = _resolveComponent("RoleDetail")!
  const _component_VZModal = _resolveComponent("VZModal")!

  return (_openBlock(), _createBlock(_component_VZModal, {
    title: `${_ctx.title}`,
    id: `${_ctx.viewName}`,
    maxWidth: "mw-900px",
    widthClass: 'w-100 w-md-900px',
    showDialog: _ctx.showDialog,
    onModalClose: _ctx.close
  }, {
    actions: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
        disabled: _ctx.loading
      }, _toDisplayString(_ctx.t("common.close")), 9, _hoisted_4)
    ]),
    default: _withCtx(() => [
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(_component_RoleDetail, {
            key: 0,
            data: _ctx.data,
            showCard: false
          }, null, 8, ["data"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    ]),
    _: 1
  }, 8, ["title", "id", "showDialog", "onModalClose"]))
}